import React, { useEffect, useState } from "react";
import pdf from "@react-pdf/renderer";
import moment from "moment";

const GeneratePDF = ({ ...props }) => {
  const { Document, Page, View, Text, StyleSheet } = pdf;
  const [data, setData] = useState({ titles: [], keys: [], data: [], pdfTitle: "" });

  useEffect(() => {
    setData(JSON.parse(props.data));
  }, [props.data]);

  const styles = StyleSheet.create({
    body: {
      display: "flex",
      width: "100%",
      fontSize: 6
    },
    pageHeading: {
      fontSize: 10,
      marginTop: "3%"
    },
    pageTitle: {
      marginLeft: "5%"
    },
    produced: {
      textAlign: "right",
      marginLeft: "30%"
    },
    titleRow: {
      flexDirection: "row",
      borderBottom: "2 black solid",
      backgroundColor: "#ACD7B3",
      marginTop: "2%",
      display: "flex",
      fontWeight: "bold"
    },
    oddRow: {
      flexDirection: "row",
      borderBottom: "1 black dashed",
      backgroundColor: "#AECEEF",
      display: "flex"
    },
    evenRow: {
      flexDirection: "row",
      borderBottom: "1 black dashed",
      backgroundColor: "#FFFFFF",
      display: "flex"
    },
    column: {
      display: "flex",
      width: "10%",
      maxWidth: "auto",
      margin: "0 10px 0 0",
      flexDirection: "column",
      padding: "5px 10px 5px 0",
      flexBasis: "100%",
      flex: "1"
    }
  });

  return (
    <Document>
      <Page>
        <View style={styles.body}>
          <View style={styles.pageHeading}>
            <div style={{ marginLeft: "5%" }}>
              <Text>{data.pdfTitle}</Text>
              <Text>Produced: {String(moment().format("MM/DD/YYYY hh:mm:ss"))}</Text>
            </div>
          </View>
          <div style={{ marginLeft: "2.5%", width: "95%" }}>
            <View style={styles.titleRow}>
              {data.titles.map((eachValue) => {
                return <Text style={styles.column}>{eachValue}</Text>;
              })}
            </View>
            {data.data.map((eachValue, index) => {
              return (
                <View style={index % 2 === 0 ? styles.evenRow : styles.oddRow} key={index}>
                  {data.keys.map((eachKey) => {
                    return <Text style={styles.column}>{eachValue[eachKey]}</Text>;
                  })}
                </View>
              );
            })}
          </div>
        </View>
      </Page>
    </Document>
  );
};

export default GeneratePDF;
